import React, { useState } from "react";
import "./Home.css";
import { RxCross2 } from "react-icons/rx";

const HomeHero = () => {

  const sparkles = Array.from({ length: 160 });

  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState("");

  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    name: "",
    email: "",
    company: "",
    message: "",
  });


  const openPopup = (type) => {
    setPopupType(type);
    setShowPopup(true);
  };


  const closePopup = () => {

    setShowPopup(false);

    setForm({
      name: "",
      email: "",
      company: "",
      message: "",
    });

  };



  const handleChange = (e) => {

    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });

  };



  const handleSubmit = async (e) => {

    e.preventDefault();

    setLoading(true);


    const formData = new FormData();


    formData.append(
      "access_key",
      "6120fc0f-c436-48c3-8d0f-9d0530bce243"
    );


    formData.append(
      "name",
      form.name
    );


    formData.append(
      "email",
      form.email
    );


    formData.append(
      "company",
      form.company
    );


    formData.append(
      "message",
      form.message
    );


    formData.append(
      "subject",
      `New ${popupType === "project" ? "Project" : "AI Audit"} Request - Vedastra`
    );


    formData.append(
      "from_name",
      "Vedastra Website"
    );


    formData.append(
      "replyto",
      form.email
    );



    try {


      const response = await fetch(
        "https://api.web3forms.com/submit",
        {
          method: "POST",
          body: formData,
        }
      );


      const result = await response.json();


      if(result.success){


        alert("Request submitted successfully!");


        setForm({
          name:"",
          email:"",
          company:"",
          message:"",
        });


        setShowPopup(false);


      }
      else{

        alert("Something went wrong!");

      }


    }
    catch(error){

      console.log(error);
      alert("Failed to submit form");

    }


    setLoading(false);

  };



  return (
    <section className="hero">


      <div className="sparkles">

        {sparkles.map((_, i) => (

          <span
            key={i}
            style={{
              left:`${Math.random()*100}%`,
              top:`${Math.random()*100}%`,
              animationDuration:`${5 + Math.random()*10}s`,
              animationDelay:`${Math.random()*0}s`
            }}
          />

        ))}

      </div>



      <div className="hero-container">


        <div className="hero-left">


          <h1 className="hero_head">
            Engineering Intelligent Digital Ecosystems
          </h1>


          <p className="hero-text">
            We build AI-powered systems, scalable products, and growth engines that help businesses operate smarter, faster, and globally.
          </p>



          <div className="hero-buttons">

            <button
              className="hero_btn"
              onClick={() => openPopup("project")}
            >
              Start a Project
            </button>

          </div>


        </div>





        <div className="hero-right">

          <img
            src="./hero-img.webp"
            alt="technology illustration"
            className="hero-image"
            loading="lazy"
          />

        </div>


      </div>



      <div className="hero-glow"></div>





      {showPopup && (

        <div
          className="popup-overlay"
          onClick={closePopup}
        >


          <div
            className="popup-box"
            onClick={(e)=>e.stopPropagation()}
          >


            <span
              className="popup-close-btn"
              onClick={closePopup}
            >
              <RxCross2 />
            </span>



            <h2 className="main-title">

              {popupType === "project"
                ? "Start Your Project"
                : "Get Free AI Audit"}

            </h2>




            <form
              className="popup-form"
              onSubmit={handleSubmit}
            >



              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={form.name}
                onChange={handleChange}
                required
              />



              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={form.email}
                onChange={handleChange}
                required
              />



              <input
                type="text"
                name="company"
                placeholder="Company Name"
                value={form.company}
                onChange={handleChange}
              />




              <textarea
                name="message"
                value={form.message}
                onChange={handleChange}
                placeholder={
                  popupType === "project"
                  ? "Tell us about your project..."
                  : "Describe your current system..."
                }
              />




              <button
                type="submit"
                className="main-btn"
                disabled={loading}
              >

                {
                  loading
                  ?
                  "Sending..."
                  :
                  "Submit"
                }

              </button>



            </form>



          </div>


        </div>

      )}



    </section>
  );
};

export default HomeHero;